import ReduxHooks from '../../store/ReduxHooks';
import { actionCreators } from '../../store/actions';
import ApiResourceManager from './ApiResourceManager';
import { buildNavigationBadges } from './transforms';

export class InitialDataManager extends ApiResourceManager {
  get = async () => {
    const response = await this.request({
      method: 'GET',
      url: '/initial-data',
    });

    if (response.success) {
      this.saveDataRedux(response.data);
    }

    return response;
  };

  saveDataRedux = (data) => {
    ReduxHooks.batchActions([
      actionCreators.initialData.set(data),
      actionCreators.sideBar.setBadge(buildNavigationBadges(data)),
    ]);
  };
}
